import { render, staticRenderFns } from "./LanguageTabs.vue?vue&type=template&id=01124d48"
import script from "./LanguageTabs.vue?vue&type=script&lang=js"
export * from "./LanguageTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports